import { render, staticRenderFns } from "./PersonBlock.vue?vue&type=template&id=b807bb6a&scoped=true"
import script from "./PersonBlock.vue?vue&type=script&lang=js"
export * from "./PersonBlock.vue?vue&type=script&lang=js"
import style0 from "./PersonBlock.vue?vue&type=style&index=0&id=b807bb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b807bb6a",
  null
  
)

export default component.exports